
import React, { Component } from 'react';
import Table from "../../Utils/Grid";
import MyModal from "../../Utils/myModal";
import { BreakLine, NewBreakLine } from '../../Utils/tableOptions';
import CustomToolbar from '../../Utils/Toolbar/CustomToolbar';
import ToolbarSelect from '../../Utils/Toolbar/ToolbarSelect';
import {RenderCurrency} from "../../Utils/renderField/renderReadField";
import NumberFormat from "react-number-format";
import moment from "moment";
import PaymentFormIgss from './PaymentForm';

const SUPERUSER = 'superuser';

class CuentaAbiertaIgss extends Component{
    state = {
        seleccionados: [],
        open_modal: false,
    }

    componentWillUnmount() {
        this.props.resetStore();
    }
    componentWillMount() {
        this.props.listar()
    }

    agregarSeleccion = (id) => {
        let seleccionados = this.state.seleccionados;
        if(seleccionados.find((item) => item.id === id)){
            seleccionados = [...seleccionados.filter((item) => item.id !== id)];
        }else{
            seleccionados.push({id: id, total: 0});
        }
        this.setState({seleccionados, open_modal: false});
    }

    render() {
        const {
            listar,
            setInitialDate,
            setFinalDate,
            payGroupIgss,
            openAccount,
            cancelOpenAccount,
        } = this.props;

        const {
            cargando,
            page,
            data,
            initial_date,
            final_date,
            saldo_total,
        } = this.props;

        console.log("OPEN ACCOUNTS: ", data);

        const options = [
            {value: 0, label: "Todas"},
            {value: 1, label: 'Cuenta'},
            {value: 2, label: 'Cirugía'},
            {value: 3, label: 'Diagnóstico'}
        ];

        return (
            <div className="content pt-3">
                <div className="m-auto row-fluid w-100">
                    <div className="table-decoration">


                    <div className="d-flex flex-row justify-content-around align-items-center">
                    <button
                        className="m-3 btn-success btn-sm cursor-pointer"
                        onClick={() => {
                            this.setState({ open_modal: true });
                        }}
                        disabled={
                            this.state.seleccionados.length > 0 ? false : true
                        }
                    > Cerrar {this.state.seleccionados.length} cuenta(s) </button>
                    <div className="top-title-toolbar">
                        <ToolbarSelect
                            titulo="CUENTAS ABIERTAS IGSS"
                            buscar={this.props.changeFilter}
                            buscador={this.props.select_search}
                            options={options}
                            valueKey="value"
                            labelKey="label"
                            autofocus
                            ancho="w-75"
                        />
                    </div>

                    <MyModal
                        isOpen={this.state.open_modal}
                        title="PAGO DE CUENTAS"
                        formId="paymentGroup"
                        classToggleButton="d-block h-100 button-service-icon"
                        body={
                            <PaymentFormIgss
                                onSubmit={async (data) => {
                                    console.log("data: ", data);
                                    const newData = {
                                        ...data,
                                        cuentas: this.state.seleccionados
                                    }

                                    const result = await payGroupIgss(newData);

                                    if (result == true) {
                                        this.setState({
                                            seleccionados: [],
                                            total: 0,
                                        });
                                        listar(1);
                                        window.scrollTo(0, 0);
                                        this.state.table_ref.current.scrollTo(
                                            0,
                                            0
                                        );
                                    }

                                    this.setState({
                                        open_modal: false,
                                    });
                                }}

                                total_cuentas={this.state.seleccionados.length}
                                initialValues={{
                                    fecha_fac: moment(
                                        Date()
                                    ).format("DD/MM/YYYY"),
                                    no_document: "",
                                    cuentas: this.state.seleccionados
                                }}
                            />
                        }
                    />

                    <div className="d-flex flex-row justify-content-end align-items-center w-50">
                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-20"
                            value={initial_date}
                            onValueChange={(values) => {
                                const dia = values.formattedValue.indexOf("D")
                                const mes = values.formattedValue.indexOf("M")
                                const anio = values.formattedValue.indexOf("Y")

                                if((dia + mes + anio) < 0){
                                    setInitialDate(values.formattedValue);
                                }
                            }}
                            autoFocus
                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}
                        />

                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-20 ml-2 mr-2"
                            value={final_date}
                            onValueChange={(values) => {
                                const dia = values.formattedValue.indexOf("D")
                                const mes = values.formattedValue.indexOf("M")
                                const anio = values.formattedValue.indexOf("Y")

                                if((dia + mes + anio) < 0){
                                    setFinalDate(values.formattedValue);
                                }
                            }}

                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}
                        />
                    <div className="top-title-toolbar mt-3">
                        <CustomToolbar
                            buscar={this.props.search}
                            buscador={this.props.buscador}
                        />
                    </div>
                    <div className='font-weight-bold ml-3 d-flex flex-row' style={{fontSize: 16}}>
                        Total:&nbsp;<RenderCurrency value={saldo_total} />
                    </div>
                    </div>
                    </div>

                        <Table
                            onPageChange={listar}
                            data={data}
                            loading={cargando}
                            page={page}
                        >
                        <TableHeaderColumn
                            tdStyle={NewBreakLine}
                            thStyle={NewBreakLine}
                            dataField="id"
                            dataFormat={(cell, row) => {
                                return(
                                    <input
                                        type="checkbox"
                                        name="seleccion[]"
                                        value={row.id}
                                        className="check-box"
                                        onChange={() => this.agregarSeleccion(row.id)}
                                        checked={this.state.seleccionados.find((item) => item.id === row.id) ? true : false}
                                    />
                                )
                            }}
                        ></TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={BreakLine}
                            thStyle={BreakLine}
                            dataField="type_procedure"
                            dataSort
                            dataFormat={(cell, row) => {
                                const description = (row.movement_account && row.movement_account.length && row.movement_account[0] &&
                                row.movement_account[0].movement_detail_movement && row.movement_account[0].movement_detail_movement.length && row.movement_account[0].movement_detail_movement[0].service.name) ? (row.movement_account && row.movement_account.length && row.movement_account[0] &&
                                    row.movement_account[0].movement_detail_movement && row.movement_account[0].movement_detail_movement.length && row.movement_account[0].movement_detail_movement[0].service.name.split(';')[0]) : ''

                                const descriptions = row.movement_account && row.movement_account.length ? row.movement_account
                                .flatMap(account => {
                                    return  account.movement_detail_movement.map(detail => {
                                        if(detail.service && detail.service.name) {
                                            return detail.service.name;
                                        }

                                        return '';
                                    }) || []
                                })
                                .filter(Boolean) // Elimina valores nulos, indefinidos o vacíos
                                .join(', ') || '' : '';

                                if(cell === 1){
                                    return (
                                        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                            <span
                                                style={{
                                                    background:'#7F7F7F',
                                                    padding:2,
                                                    color:'white',
                                                    borderRadius:5,
                                                    fontSize:11
                                                }}
                                            >cuenta</span>&nbsp;
                                            <small>
                                                {descriptions.split(';').map((desc, index) => (
                                                    <span key={index}>
                                                        {desc}
                                                    </span>
                                                ))}
                                            </small>
                                        </span>
                                    );
                                }else if(cell === 2){
                                    return(
                                        <span style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                            <span
                                                style={{
                                                    background:'#0a5995',
                                                    padding:2,
                                                    color:'white',
                                                    borderRadius:5,
                                                    fontSize:11
                                                }}
                                            >cirugía</span>&nbsp;
                                            <small>
                                                {descriptions.split(';').map((desc, index) => (
                                                    <span key={index}>
                                                        {desc}
                                                    </span>
                                                ))}
                                            </small>
                                        </span>
                                    );
                                }else if(cell === 3){
                                    return(
                                        <span style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                            <span
                                                style={{
                                                    background:'#459058',
                                                    padding:2,
                                                    color:'white',
                                                    borderRadius:5,
                                                    fontSize:11
                                                }}
                                            >diagnóstico</span>&nbsp;
                                            <small>
                                                {descriptions.split(';').map((desc, index) => (
                                                    <span key={index}>
                                                        {desc}
                                                    </span>
                                                ))}
                                            </small>
                                        </span>
                                    );
                                }
                            }}
                            >Tipo de cuenta</TableHeaderColumn>

                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="patient"
                                dataSort
                                dataFormat={(cell, row)=>{
                                    if(row.patient){
                                        return row.patient.first_name + " " + row.patient.last_name;
                                    }else{
                                        return "---";
                                    }

                                }}
                                >Paciente</TableHeaderColumn>
                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="referent"
                                dataSort
                                dataFormat={(cell, row) => {
                                    if(row.referent){
                                        return row.referent.name;
                                    }else{
                                        return "";
                                    }
                                }}
                                >Referente</TableHeaderColumn>
                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataFormat={(cell, row)=>{
                                    return (
                                        <React.Fragment>
                                            <span>Saldo pendiente:</span><br />
                                            <span>Q{row.saldo_pendiente}</span>
                                        </React.Fragment>
                                    );
                                }}
                                dataSort>Estado</TableHeaderColumn>

                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="made"
                                dataSort>Fecha</TableHeaderColumn>

                            <TableHeaderColumn
                                dataField="id"
                                isKey={true}
                                dataAlign="center"

                                dataFormat={(cell)=>{
                                    return(
                                        <React.Fragment>
                                            <span className="account" onClick={()=>openAccount(cell)}>Cargar</span>
                                            {this.props.usuario.role_name === SUPERUSER &&
                                                <span  className="cancel-account" onClick={()=>cancelOpenAccount(cell)}>Anular</span>
                                            }
                                        </React.Fragment>
                                    );
                                }}
                                >Acciones</TableHeaderColumn>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}

export default CuentaAbiertaIgss;
